import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.EXECUTIVE_SUMMARY}.${BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.FINANCIAL_INFORMATION}` as const;

export const EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES = {
  AVERAGE_ANNUAL_PROFIT: 'averageAnnualProfit',
  PROJECTED_ANNUAL_PROFIT: 'projectedAnnualProfit',
  INTERNAL_RATE_OF_RETURN: 'internalRateOfReturn',
  ASSETS_SIZE: 'assetsSize',
  RETURN_ON_INVESTMENT: 'returnOnInvestment',
} as const;

export interface IFinancialInfoExecutiveSummaryForm {
  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.AVERAGE_ANNUAL_PROFIT]: string;
  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.PROJECTED_ANNUAL_PROFIT]: string;
  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.INTERNAL_RATE_OF_RETURN]: string;
  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.ASSETS_SIZE]: string;
  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.RETURN_ON_INVESTMENT]: string;
}

export const financialInfoExecutiveSummaryInitialValues: IFinancialInfoExecutiveSummaryForm = {
  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.AVERAGE_ANNUAL_PROFIT]: '',
  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.PROJECTED_ANNUAL_PROFIT]: '',
  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.INTERNAL_RATE_OF_RETURN]: '',
  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.ASSETS_SIZE]: '',
  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.RETURN_ON_INVESTMENT]: '',
};
